import React from 'react';
import PropTypes from 'prop-types';
import { ComponentLoader } from '../../../global/ComponentLoader/ComponentLoader';

const importFunc = () => {
    return import(
        /* webpackChunkName: "PdpSharedShippingModal" */
        './PdpSharedShippingModal'
    ).then(({ PdpSharedShippingModal }) => PdpSharedShippingModal);
};

function PdpSharedShippingModalLoader(props) {
    return <ComponentLoader {...props} load={props.isOpened} importFunc={importFunc} />;
}

PdpSharedShippingModalLoader.propTypes = {
    currency: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    environment: PropTypes.object.isRequired,

    showDetails: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    closeShippingModal: PropTypes.func.isRequired,
};

export { PdpSharedShippingModalLoader };
